import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { COMPANY_INFO } from '../data/scrapeData';

export default function Footer() {
  const location = useLocation();
  const currentPath = location.pathname;

  const isNavActive = (path) => {
    if (path === '/') {
      return currentPath === '/';
    }
    return currentPath.startsWith(path);
  };

  return (
    <footer className="w-full bg-black text-white px-6 py-12 md:px-16 md:py-16 border-t border-neutral-800">
      <div className="max-w-7xl mx-auto">
        
        {/* Main Top Content Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-start">
          
          {/* Left Column: Company Info */}
          <div className="md:col-span-7 space-y-6">
            <h2 className="text-xl md:text-2xl font-bold tracking-tight text-white">
              {COMPANY_INFO.name}
            </h2>

            <div className="space-y-1 text-sm font-normal leading-relaxed text-gray-300">
              <p>{COMPANY_INFO.owner}</p>
              <p>{COMPANY_INFO.address}</p>
              <p>{COMPANY_INFO.city}.</p>
            </div>

            <div className="space-y-1 text-sm font-normal pt-2 text-gray-300">
              <p className="whitespace-nowrap">
                <span className="font-medium text-white">Tlf :</span>{' '}
                <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="hover:text-white transition-opacity whitespace-nowrap">
                  {COMPANY_INFO.phone}
                </a>
              </p>
              <p className="whitespace-nowrap">
                <span className="font-medium text-white">Mail:</span>{' '}
                <a href={`mailto:${COMPANY_INFO.email}`} className="hover:text-white transition-opacity whitespace-nowrap">
                  {COMPANY_INFO.email}
                </a>
              </p>
            </div>
          </div>

          {/* Center Divider Line (Desktop Only) */}
          <div className="hidden md:flex md:col-span-1 justify-center self-stretch">
            <div className="w-px bg-neutral-800 h-full"></div>
          </div>

          {/* Right Column: Navigation Links */}
          <div className="md:col-span-4 space-y-5">
            {/* Active Nav Item highlight or Forside */}
            <div className={isNavActive('/') ? "border-b-2 border-white pb-2 inline-block" : "pb-2 inline-block"}>
              <Link 
                to="/" 
                className={`text-base ${isNavActive('/') ? 'font-semibold text-white' : 'font-medium text-gray-300 hover:text-white transition-opacity'}`}
              >
                Forside
              </Link>
            </div>

            {/* Links List */}
            <ul className="space-y-4 pt-1 text-base font-medium text-white">
              <li>
                <Link 
                  to="/ydelser/" 
                  className={`inline-flex items-center gap-2 hover:opacity-80 transition-opacity ${isNavActive('/ydelser') ? 'font-semibold border-b-2 border-white pb-1' : ''}`}
                >
                  <span>Ydelser</span>
                  <svg className="w-3.5 h-3.5 stroke-current" fill="none" viewBox="0 0 24 24" strokeWidth="2.5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                  </svg>
                </Link>
              </li>
              <li>
                <Link 
                  to="/maskiner/" 
                  className={`hover:opacity-80 transition-opacity inline-block ${isNavActive('/maskiner') ? 'font-semibold border-b-2 border-white pb-1' : ''}`}
                >
                  Maskiner/Materialer
                </Link>
              </li>
              <li>
                <Link 
                  to="/om-os/" 
                  className={`hover:opacity-80 transition-opacity inline-block ${isNavActive('/om-os') ? 'font-semibold border-b-2 border-white pb-1' : ''}`}
                >
                  Om os
                </Link>
              </li>
              <li>
                <Link 
                  to="/kontakt/" 
                  className={`hover:opacity-80 transition-opacity inline-block ${isNavActive('/kontakt') ? 'font-semibold border-b-2 border-white pb-1' : ''}`}
                >
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Copyright Strip */}
        <div className="mt-16 pt-6 border-t border-neutral-800 text-xs text-neutral-300 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p>© Copyright 2024 – Vognmand & Entreprenør DBM Aps | Mail: <a href={`mailto:${COMPANY_INFO.email}`} className="hover:text-white transition-colors whitespace-nowrap">{COMPANY_INFO.email}</a> | Telefon: <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="hover:text-white transition-colors whitespace-nowrap">{COMPANY_INFO.phone}</a></p>
          <div className="flex flex-wrap items-center gap-4 text-xs">
            <a href="https://www.iubenda.com/privacy-policy/96440832" className="iubenda-white iubenda-noiframe iubenda-embed hover:text-white transition-colors" title="Privatlivspolitik ">Privatlivspolitik</a>
            <span className="text-neutral-600 hidden sm:inline">|</span>
            <a href="https://www.iubenda.com/privacy-policy/96440832/cookie-policy" className="iubenda-white iubenda-noiframe iubenda-embed hover:text-white transition-colors" title="Cookiepolitik ">Cookiepolitik</a>
          </div>
        </div>

      </div>
    </footer>
  );
}
